<template>
  <li :class="['timeline-item', {'timeline-inverted': timelineInverted}]">
    <slot></slot>
  </li>
</template>

<script>
export default {
  name: 'timeline-item',
  props: {
    timelineInverted: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
  li.timeline-item {
    margin-bottom: 20px;
    position: relative;
  }
  li.timeline-item:before,
  li.timeline-item:after {
    content: " ";
    display: table;
  }

  li.timeline-item:after {
    clear: both;
  }

  li.timeline-item:before,
  li.timeline-item:after {
    content: " ";
    display: table;
  }

  li:after {
    clear: both;
  }
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Timeline/TimelineItem.vue